module.exports = __webpack_public_path__ + "static/media/3dots.7d03be5f.svg";